import React from "react";
import { Font, Page, Text, View, Document, Image } from "@react-pdf/renderer";

import CDK_Logo from "../../images/CDKGlobalWM_BLK.jpg";
import Signature from "../../images/Signature.png";
import RobotoMediumFont from "../../util/Fonts/Roboto-Medium.ttf";
import RobotoMediumItalic from "../../util/Fonts/Roboto-MediumItalic.ttf";
import RobotoRegular from "../../util/Fonts/Roboto-Regular.ttf";
import { getImage } from "../../util/helpers";

import styles from "./sezPdfStyles";

Font.register({
  family: "Roboto",
  fonts: [
    {
      src: RobotoRegular
    },
    {
      src: RobotoMediumFont,
      fontWeight: "medium"
    },
    {
      src: RobotoMediumItalic,
      fontWeight: "medium",
      fontStyle: "italic"
    }
  ]
})

export const SEZPDFTemplate = ({ employee = {} }) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Image style={styles.cdkLogo} src={CDK_Logo} />
        <View style={styles.header}>
          <View style={styles.headerinfo}>
            <Text style={styles.title}>
              Application Form for Permanent/Temporary Identity Card
            </Text>
            <Text style={styles.boldItalicText}>(To be filled by the Applicant)</Text>
            <Text> </Text>
            <Text style={styles.boldText}>CDK Global (India) Pvt Ltd. </Text>
            <Text>(Special Economic Zone)</Text>
            <Text>5th Floor, Building No.12 B, Sundew Properties Ltd-SEZ,</Text>
            <Text>Madhapur, Raheja Mindspace, Hyderabad, Rangareddy, Telangana – 500 081.</Text>
          </View>

          <Image style={styles.image} src={getImage(employee.employeePhoto)} />
        </View>
        <View style={styles.table}>
          <View style={{ ...styles.tableRow, ...styles.boldText }}>
            <Text style={styles.tablecellLeft}>Name Of The Company/Unit</Text>
            <Text style={styles.tablecellRight}>
              CDK Global (India) Pvt. Ltd.
            </Text>
          </View>

          <View style={styles.tableRow}>
            <Text style={styles.tablecellLeft}>Name Of The Employee</Text>
            <Text style={styles.tablecellRight}>{employee.employeeName}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tablecellLeft}>Designation</Text>
            <Text style={styles.tablecellRight}>{employee.designation}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tablecellLeft}>
              {employee.relationShipWithMe}
            </Text>
            <Text style={styles.tablecellRight}>{employee.relativeName}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tablecellLeft}>Temporary Address</Text>
            <Text style={styles.tablecellRight}>
              {employee.temporaryAddress}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tablecellLeft}>
              Permanent Residence Address
            </Text>
            <Text style={styles.tablecellRight}>
              {employee.permanentResidenceAddress}
            </Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tablecellLeft}>Date of Birth</Text>
            <Text style={styles.tablecellRight}>{employee.dateOfBirth}</Text>
          </View>
          <View style={styles.tableRow}>
            <Text style={styles.tablecellLeft}>Date of Joining</Text>
            <Text style={styles.tablecellRight}>{employee.dateofJoining}</Text>
          </View>
          <View style={styles.lastTableRow}>
            <Text style={styles.tablecellLeft}>Identification Mark</Text>
            <Text style={styles.tablecellRight}>
              {employee.identificationMark}
            </Text>
          </View>
        </View>
        <View style={styles.details}>
          <View style={styles.signature}>
            <View style={styles.employeeSignature}>
              <Text style={styles.signatureName}>{employee.employeeName}</Text>
              <Text>________________________________</Text>
              <Text style={styles.signatureSubText}>Signature of Employee</Text>
            </View>
            <View style={styles.cdkSignature}>
              <Image style={styles.signatureImage} src={Signature} />
              <Text>___________________________________________________</Text>
              <Text style={styles.signatureSubText}>
                Signature of Authorized Signatory
              </Text>
              <Text style={styles.headSignatureName}>(Rahul Shirodkar)</Text>
            </View>
          </View>

          <View style={styles.signatureLine} />

          <View style={styles.bottomText}>
            <Text style={styles.textCenter}> (For Office Use Only) </Text>
            <Text>
              Entry for
              Mr./Ms./Mrs._______________________________________________________________________________
            </Text>
            <Text>
              S/o / D/o / w/o /Shri_________________________________________________________has
              been made in the Register of 
            </Text>
            <View style={styles.bottomSubText}>
              <Text>
                M/s CDK Global (India) Pvt Ltd. (Special Economic
                Zone) 5th Floor, Building No.12 B, Sundew Properties
              </Text>
              <Text>
                Ltd-SEZ, Madhapur, Raheja Mindspace, Hyderabad, Rangareddy, Telangana at Sr.
                No.________________at Page No_________.Now Mr. / Ms. / Mrs._____________________
                 is allowed to get entry in M/s CDK Global (India) Pvt Ltd.
              </Text>
              <Text>
              (Special Economic Zone) by showing his Permanent identity Card, bearing
                No________________________.
              </Text>
            </View>

            <View style={styles.bottomSign}>
              <Text>_____________________________________________________</Text>
              <Text> (Signature of Development Commissioner)</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};
